import { Spinner } from "@styles/loading";

export const CustomLoader = ({ text }) => (
	<div className="d-flex justify-content-center align-items-center mt-5">
		<Spinner />
		{text && <h2 className="ms-2">{text}</h2>}
	</div>
);